import Detect from '@/lib/Detect';

export default {
  install(Vue) {
    Vue.$device = Object.freeze(Detect);
    Vue.prototype.$device = Object.freeze(Detect);
  },
};
